import { Dispatch} from "react";
import { useConfigService } from './useConfigService';
import { useContentService } from './useContentService';
import { IADPActions } from "../state/Actions";
import { IADPState} from "../types";
import { actions } from "../state";
import { useIPCBridge } from "./useIPCBridge";
import { useDedupEffect } from "../util/useDedupEffect";
import { useDeviceValidationService } from "./useDeviceValidationService";
const logPrefix = "[ADPClient][InitilizeServiceHook]"

export function useInitilizeService( dispatch: Dispatch<IADPActions>,appState: IADPState) {
   const {postAllValidationLogsFromIndexDB} = useDeviceValidationService(dispatch,appState);
   const config = useConfigService(dispatch);
   const {fetchContent}= useContentService(dispatch);
   const {sendGreeting} = useIPCBridge(dispatch,appState);
   useDedupEffect(() => {
      if (!config) {
        return;
      }
      console.log(logPrefix, "initializing ADP app...");
     dispatch(actions.createSetConfigAction(config));
     fetchContent(appState.sessionState.selectedLanguage === "english" ? "en" : "es",true).then((result)=>{   
      if(result){
        console.log(logPrefix, "ADP app is initilized...");
        sendGreeting(); 
        postAllValidationLogsFromIndexDB(config);
      }
     });   
    }, [config]);
    return config;
}
